import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { toggleValue } from "./helper";
import { CLEAR_ALL, SELECT, SET_ALL, TOGGLE } from "./types";
export function reducer(state, _ref) {
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case SELECT:
      return areEqual([payload], state.rows) ? _objectSpread(_objectSpread({}, state), {}, {
        all: !1
      }) : _objectSpread(_objectSpread({}, state), {}, {
        all: !1,
        rows: [payload]
      });
    case TOGGLE:
      var rows = state.rows,
        newRows = toggleValue(rows, payload);
      return _objectSpread(_objectSpread({}, state), {}, {
        all: !1,
        rows: newRows
      });
    case SET_ALL:
      return areEqual(payload, state.rows) ? _objectSpread(_objectSpread({}, state), {}, {
        all: !0
      }) : _objectSpread(_objectSpread({}, state), {}, {
        all: !0,
        rows: payload
      });
    case CLEAR_ALL:
      return state.rows.length ? _objectSpread(_objectSpread({}, state), {}, {
        all: !1,
        rows: []
      }) : _objectSpread(_objectSpread({}, state), {}, {
        all: !1
      });
    default:
      return state;
  }
}
function areEqual(array1, array2) {
  return array1.length === array2.length && array1.every(function (item) {
    return _includesInstanceProperty(array2).call(array2, item);
  });
}